import { ApiError } from "./api.ts";

/**
 * Текст отказа при загрузке курсорного списка. Одна функция на все такие
 * списки: домашку, занятия на карточке ученика и «Уроки».
 *
 * Три случая, и путать их нельзя:
 * - `invalid_cursor` это наш отказ, а не сеть: курсор снят с устаревшего
 *   чтения, и помогает только перезагрузка страницы;
 * - прочий отказ сервера: сеть работает, а мы попросили не то. Текст даёт
 *   вызывающий, если у него есть свой, иначе показывается сообщение отказа;
 * - всё остальное это обрыв связи. Пустой экран без объяснения на плохом
 *   канале читается как «ничего нет», и это неправда.
 */
export function listErrorText(e: unknown, otherApiText?: string): string {
  if (e instanceof ApiError) {
    if (e.code === "invalid_cursor") return "Список устарел. Обновите страницу.";
    return otherApiText ?? e.message;
  }
  return "Нет связи. Проверьте интернет и попробуйте ещё раз.";
}
